import axios, { AxiosResponse } from "axios";

const http = axios.create({
    baseURL: "api/",
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
});

export interface PaymentSolutionNameRequest {
    paymentSolutionName: string;
}

export interface LanguageCulture {
    culture: string;
    label: string;
}

export interface BusinessUnitDetails {
    businessUnitName: string;
    fullsteamEmail: string;
    logoArray: string;
    languageCultures: LanguageCulture[];
}

export interface MerchantApplicationRequest {
    paymentSolutionName: string;
    applicantEmailAddress: string;
    legalBusinessName: string;
    doingBusinessAs: string;
    languageCulture: string;
    businessUnitCustomerId: string | null;
    merchantApplicationIdentifier: string | null;
}

export interface ValidationRequest {
    businessUnitCustomerId: string | null;
    merchantApplicationIdentifier: string | null;
}

export interface ValidationResponse {
    isValid: boolean;
}

export interface MerchantApplicationDetails {
    merchantApplicationLink: string;
}

export const getBusinessUnitDetails = async (paymentSolutionNameRequest: PaymentSolutionNameRequest): Promise<AxiosResponse<BusinessUnitDetails>> => {
    try {
        const response = await http.get(`boarding/getBusinessUnitDetails/${paymentSolutionNameRequest.paymentSolutionName}`);
        return response;
    } catch (error) {
        console.error('Error fetching business unit details:', error);
        throw error;
    }
};

export const getValidation = async (request: ValidationRequest): Promise<AxiosResponse<ValidationResponse>> => {
    try {
        const response = await http.post(`boarding/validate`, request);
        return response;
    } catch (error) {
        console.error('Error on validation:', error);
        throw error;
    }
};

export const createMerchantApplication = async (request: MerchantApplicationRequest): Promise<AxiosResponse<MerchantApplicationDetails>> => {
    try {
        const response = await http.post("boarding/createMerchantApplication", request);
        return response;
    } catch (error) {
        console.error('Error Creating a Merchant Application:', error);
        throw error;
    }
};
